import { InjectionToken } from "@angular/core";
import { PositionCatalogPort } from "./position-catalog.port";

export const POSITION_CATALOG_PORT = new InjectionToken<PositionCatalogPort>(
  "POSITION_CATALOG_PORT",
);
